// extracted by mini-css-extract-plugin
module.exports = {"fixedWidth":"index-module--fixedWidth--Ti8xW"};